import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {FdFieldConfigs} from '../../shared/fd-form-components/fd-form-components.module';
import {FileContentTypeEnum} from '../../shared/enums/file-content-type.enum';
import {HttpErrorResponse} from '@angular/common/http';
import {Messages} from '../../shared/messages/messages';
import {EconomicalGroupService} from '../services/economical-group.service';
import {FileService} from '../../shared/service/file.service';
import {LoadingService} from '../../shared/service/loading.service';
import {ErrorService} from '../../shared/service/error.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {ProfileModel} from '../../shared/models/profile.model';
import {EconomicalGroupModel} from '../../shared/models/economical-group.model';
import {finalize} from 'rxjs/operators';
import {DialogService} from '../../shared/service/dialog.service';

@Component({
    selector: 'app-edit-economical-group',
    templateUrl: './edit-economical-group.component.html',
    styleUrls: ['./edit-economical-group.component.scss'],
    standalone: false
})
export class EditEconomicalGroupComponent implements OnInit {

  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;
  data = new FormData();
  fileName: string;

  @ViewChild('hiddenUpload') hiddenUpload: ElementRef;

  constructor(private groupService: EconomicalGroupService,
              private fileService: FileService,
              private dialogService: DialogService,
              private loadingService: LoadingService,
              private errorService: ErrorService,
              private formBuilder: UntypedFormBuilder,
              private dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) public group: EconomicalGroupModel) { }

  ngOnInit() {
    this.createFormGroup();
    this.fields = this.createFields();
    this.formGroup.controls.name.setValue(this.group.nameGroup);
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    if (!this.formGroup.valid) {
      this.dialogService.openDialog(Messages.DATA_REQUIRED_ERROR);
      return;
    }

    this.loadingService.show();
    this.data.append('name', this.formGroup.value.name);
    this.data.append('service-contract', this.group.serviceContract);
    this.groupService.update(this.data, this.group.idEconomicGroup).
    pipe(finalize(() => this.loadingService.hide()))
      .subscribe((response) => {
         if (response.invalidCNPJs) {
             this.dialogService.openDialog(Messages.ECONOMIC_GROUP_DUPLICATED_CNPJ, () => this.close());
             this.fileService.saveFileFromBase64(response.details, FileContentTypeEnum.CSV, 'detalhes_grupo_economico.csv');
         } else {
             this.dialogService.openDialog(Messages.EDIT_SAVE_SUCCESS, () => this.close());
         }
      }, (err: HttpErrorResponse) => this.errorService.handleXHRError(err, Messages.EDIT_SAVE_ERROR));
  }

  setFile(filesParams: FileList) {
    const newFileList = new Array<File>();
    const csvType = '.csv';
    const formData = new FormData();
    const length = filesParams.length;

    for (let i = 0; i < length; i++) {
      const file: File = filesParams[i];
      if (file.name.match(csvType)) {
        newFileList.push(file);
        this.fileName = file.name;
        var blob = new Blob([file], { type: 'text/csv'});
        formData.append('file', blob, file.name);
      }
    }

    this.data = formData;
  }

  createFormGroup() {
    this.formGroup = this.formBuilder.group({
      name: ['', Validators.required]
    });
  }

  createFields(): FdFieldConfigs {
    return {
      name: {
        label: 'Nome do grupo econômico',
        controlName: 'name',
        messages: {
          required: 'Informe um nome'
        }
      }
    };
  }

  openFileExplorer() {
    let el: HTMLInputElement =
      this.hiddenUpload.nativeElement.querySelector(
        'ngx-mat-file-input[name="upload-start"] input[type="file"]'
      ) as HTMLInputElement;
    el.value = "";
    el.click();

  }

  downloadCnpjFile() {
    this.loadingService.show();
    this.groupService.getCnpjFileById(this.group.idEconomicGroup).
    pipe(finalize(() => this.loadingService.hide())).
    subscribe(
      (data) => {
        this.fileService.saveFile(data, FileContentTypeEnum.CSV, 'cnpjs.csv');
      },
      (err: HttpErrorResponse) => {this.errorService.handleXHRError(err, Messages.SEARCH_ERROR); });
  }
}
